// extracted by mini-css-extract-plugin
export var content = "_qx-1";
export var noScroll = "_qx-3";
export var paper = "_qx-0";
export var scrollable = "_qx-2";